import { useRef, useEffect } from 'react';

function PrivacyPolicy() {
  const divRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!divRef.current) return;
    const scriptTwo = document.createElement('script');
    scriptTwo.type = 'text/javascript';
    scriptTwo.innerHTML = `OneTrust.NoticeApi.Initialized.then(function() {
        OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/storage-container/73dca12b-5ba4-4937-9072-b5ffa15d1ba7/privacy-notices/71d873af-72cf-4dd7-a63f-5f24e616f482/published/privacynotice.json"]);
      });`;
    divRef.current.appendChild(scriptTwo);
  }, []);

  return (
    <div ref={divRef}>
      {/* <!-- OneTrust Privacy Notice start -->
      <!-- Language Drop-down element that will control in which language the Privacy Notice is displayed --> */}
      <div className="ot-privacy-notice-language-dropdown-container"></div>
      {/* <!-- Container in which the Privacy Notice will be rendered --> */}
      <div
        id="otnotice-71d873af-72cf-4dd7-a63f-5f24e616f482"
        className="otnotice"
      ></div>
      {/* <!-- OneTrust Privacy Notice end --> */}
    </div>
  );
}

export default PrivacyPolicy;
